<template>
  <div class="key-value-wrapper">
    <div
      class="key-value-item"
      :class="{ between }"
      :style="{ flex: `0 0 ${100 / col}%` }"
      v-for="item of value"
      :key="item.label"
    >
      <div class="label">{{ item.label }}：</div>
      <div class="value">{{ item.value }}</div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'xw-label-value',
  props: {
    value: Array,
    col: {
      type: Number,
      default: 2,
    },
    between: Boolean,
  },
}
</script>
<style lang="stylus" scoped>
.key-value-wrapper
  display flex
  flex-wrap wrap

  .key-value-item
    display flex
    margin-bottom 10px
    align-items: center

    &.between
      justify-content space-between

    .label
      font-size 14px
      color #797979

    .value
      font-size 14px
      color #252530
      max-width:240px
</style>
